<div class="cco">
  <div class="cco__prologue">
    <mat-icon class="cco__icon">info</mat-icon>
    <h3 class="cco__headline" i18n="@@uiElements-youtubeVideoConsent-headline">Empfohlene YouTube-Videos</h3>
  </div>
  <p class="cco__text" i18n="@@uiElements-youtubeVideoConsent-text">
    Durch Akzeptieren stimmen Sie einerseits der Verwendung von Cookies und anderer Technologien zur Verarbeitung Ihrer
    personenbezogenen Daten als solche, sowie andererseits der Datenübermittlung in die USA, zu. Sie finden weitere
    Informationen, wenn Sie <a routerLink="/legal/privacy-policy">hier</a> klicken.
  </p>
  <mat-slide-toggle
    [disabled]="acceptedCookieConsent"
    (toggleChange)="acceptCookieConsent()"
    i18n="@@uiElements-youtubeVideoConsent-button"
    >Akzeptieren und Videos anzeigen</mat-slide-toggle
  >
</div>
